import z from "zod";

import { sizeAttributeSchema } from "@frontend/bridge/sizeSchema";

import { DIALOG_PLACEMENTS, DIALOG_SIZES } from "./constants";

export const dialogDataSchema = z.object({
  title: z.string().optional(),
  size: sizeAttributeSchema(DIALOG_SIZES).optional(),
  placement: z.enum(DIALOG_PLACEMENTS).optional(),
});

export type DialogDataProps = z.infer<typeof dialogDataSchema>;

export const dialogFooterDataSchema = z.object({});

export type DialogFooterDataProps = z.infer<typeof dialogFooterDataSchema>;
